export const MEMBER_AREA_COPY_STATUS = {
  copying: 'copying',
  done: 'done',
  failed: 'failed',
};

export const MEMBER_AREA_COPY_POLL_INTERVAL_MS = 30000;

export const MEMBER_AREA_COPYING_ERROR_CODE = 'member_area_copying';

export const MEMBER_AREA_COPY_TEXTS = {
  copying:
    'Estamos copiando a área de membros do produto original. Você vai receber um e-mail e uma notificação quando ela estiver pronta.',
  failed:
    'Não conseguimos copiar a área de membros do produto original. Você pode montá-la aqui ou duplicar o produto de novo.',
  writeRefused: 'A área de membros ainda está sendo copiada.',
};

export function isMemberAreaCopyingError(error) {
  return (
    error?.response?.status === 409 &&
    error?.response?.data?.code === MEMBER_AREA_COPYING_ERROR_CODE
  );
}

export function resolveMemberAreaCopyingErrorMessage(error) {
  const detail = error?.response?.data?.detail;

  return typeof detail === 'string' && detail.trim()
    ? detail.trim()
    : MEMBER_AREA_COPY_TEXTS.writeRefused;
}
